import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, inject } from "vue";
import { useDeviceStore } from "@/stores/deviceStore";
import { useSurveyStore } from "@/stores/surveyStore";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import Modal from "../shared/modal/base/Modal.vue";
import ServiceEvaluationQuestions from "./ServiceEvaluationQuestions.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceEvaluation',
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const deviceStore = useDeviceStore();
const surveyStore = useSurveyStore();
const serviceEvaluationQuestions =
  ref<InstanceType<typeof ServiceEvaluationQuestions>>();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const isShowingKeyboard = computed(() => deviceStore.isShowingKeyboard);
watch(isShowingKeyboard, (isShowingKeyboard) => {
  if (isShowingKeyboard) {
    setTextAreaScroll();
    return;
  }
});

/** 서비스 평가 불가 팝업 처리 */
const showModalNotEvaluatingService = ref(false);
const toggleShowModalNotEvaluatingService = (show: boolean) => {
  showModalNotEvaluatingService.value = show;
};
const onCloseServiceEvaluation = () => {
  emit("onClickClose");
};

const lineSurvey = computed(() => surveyStore.lineSurvey);
const isEvaluable = computed(() => !!serviceEvaluationQuestions.value?.isValid);

const onClickEvaluate = async () => {
  if (!serviceEvaluationQuestions.value) return;

  const userAnswers = new Map(
    [...serviceEvaluationQuestions.value.userAnswers.entries()].sort()
  );
  const selectedTurnId = serviceEvaluationQuestions.value.selectedTurnId;

  const sendSurveyResult = await surveyStore.sendSurveyResult(
    lineSurvey.value!.id,
    userAnswers,
    selectedTurnId
  );

  if (!sendSurveyResult.isSuccess) {
    showErrorModal(
      "서비스평가 제출 오류",
      sendSurveyResult.errorMessage,
      sendSurveyResult.resultCode,
      sendSurveyResult.errorTime
    );
    return;
  }

  showToastMessage("서비스 평가 완료되었습니다.", 3000, 350);
  onCloseServiceEvaluation();
};

const textArea = ref();
const serviceEvaluation = ref();
const setTextAreaScroll = () => {
  const textAreaY = textArea.value?.getBoundingClientRect().top || 0;
  const serviceEvaluationY =
    serviceEvaluation.value.getBoundingClientRect().top;
  const offset = textAreaY - serviceEvaluationY;
  serviceEvaluation.value.scrollTo({
    top:
      offset > 0
        ? offset + serviceEvaluation.value.scrollTop
        : serviceEvaluation.value.scrolltop,
    behavior: "smooth",
  });
};

const __returned__ = { emit, deviceStore, surveyStore, serviceEvaluationQuestions, showErrorModal, showToastMessage, isShowingKeyboard, showModalNotEvaluatingService, toggleShowModalNotEvaluatingService, onCloseServiceEvaluation, lineSurvey, isEvaluable, onClickEvaluate, textArea, serviceEvaluation, setTextAreaScroll, NavigationBar, FooterButton, Modal, ServiceEvaluationQuestions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})